import "./newCategory.css"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { addCategory } from "../../redux/apiCalls"
import { Snackbar, IconButton } from "@mui/material"
import { Close } from "@material-ui/icons"
import { renderErrorMsg } from "../../services/errorsForm"
import { onImageUpload } from "../../services/uploadImage"

export default function NewCategory() {
  const [categoryForm, setCategoryForm] = useState()
  const dispatch = useDispatch()
  const [formErrorMsg, setFormErrorMsg] = useState()
  const [imageUrl, setImageUrl] = useState()
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false)
  //add a new category
  const handleChangeForm = (e) => {
    setCategoryForm({
      ...categoryForm,
      [e.target.name]: e.target.value,
    })
  }
  const handleChangeImage = (e) => {
    onImageUpload(e, setSubmitBtnDisabled, setFormErrorMsg, setImageUrl)
  }

  const onAddCategory = (e) => {
    e.preventDefault()
    if (categoryForm === undefined) {
      return false
    }
    const newCategory = { ...categoryForm, image: imageUrl }

    addCategory(dispatch, newCategory, handleClick, setFormErrorMsg)
    document.getElementById("addCategoryForm").reset()
  }

  // snackbar when category is added
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return
    }
    setOpen(false)
  }
  const closeSnackbarButton = (
    <IconButton
      size='small'
      aria-label='close'
      color='inherit'
      onClick={handleClose}>
      <Close fontSize='small' color='white' />
    </IconButton>
  )
  return (
    <div className='newCategory'>
      <h1 className='addCategoryTitle'>New Category</h1>
      <form className='addCategoryForm' id='addCategoryForm'>
        <div className='addCategoryItem'>
          <label>Image</label>
          <input type='file' name='image' onChange={handleChangeImage} />
          {renderErrorMsg(formErrorMsg, "image")}
        </div>
        <div className='addCategoryItem'>
          <label>Name</label>
          <input
            type='text'
            name='name'
            placeholder='Category name'
            onChange={handleChangeForm}
          />
          {renderErrorMsg(formErrorMsg, "name")}
        </div>
        <div className='addCategoryItem'>
          <label>Description</label>
          <textarea
            type='text'
            name='description'
            placeholder='Category description'
            row='4'
            col='50'
            onChange={handleChangeForm}
          />
          {renderErrorMsg(formErrorMsg, "description")}
        </div>
        <button
          className='addCategoryButton'
          onClick={onAddCategory}
          disabled={submitBtnDisabled}>
          Create
        </button>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message='Category Added'
          action={closeSnackbarButton}
        />
      </form>
    </div>
  )
}
